import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const ROOM_CONFIG_BUILDING =
  FORM_FIELDS.INVENTORY.ROOM_CONFIG_BUILDING_TAB;

export const roomConfigBuildingValidationSchema = yup.object().shape({
  [ROOM_CONFIG_BUILDING.OFFICE]: yup
    .string()
    .required("Office Location is required"),

  [ROOM_CONFIG_BUILDING.BUILDING]: yup
    .string()
    .required("Building Name is Required"),

  [ROOM_CONFIG_BUILDING.FLOOR]: yup
    .string()
    .required("Floor Number is Required"),
});

export type RoomConfigBuildingSchemaType = yup.InferType<
  typeof roomConfigBuildingValidationSchema
>;
